<template>
	<div>
		<div class="home-header-container" :class="'route-'+routeName">
			<div class="home-header-logo" @click="bus.emit('goHome')">
				<img src="@/assets/images/home_logo.png" alt="">
			</div>
			<el-menu class="home-header-menu" mode="horizontal">
				<el-menu-item v-for="(item,key) in headerItem" :key="key">
					<router-link :to="item.url" exact active-class="active"
					             v-if="item.type === 0">{{ item.name }}
					</router-link>
					<a @click="item.url" v-else-if="item.type === 1">{{ item.name }}</a>
				</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount} from "vue"
import router from "@/router";
import bus from "@/plugins/bus";


import {useGlobalStore} from '@/pinia'

const globalStore = useGlobalStore()

const headerItem = ref([
	{
		type: 0,
		name: "首页",
		url: "/",
		className: "Home"
	},
	{
		type: 0,
		name: "新手教程",
		url: "/course",
		className: "Course"
	},
	{
		type: 0,
		name: "成长福利",
		url: "/level",
		className: "Level"
	},
	{
		type: 0,
		name: "在线客服",
		url: "/service",
		className: "Service"
	},
	{
		type: 1,
		name: "会员中心",
		url: function () {
			bus.emit('goUserCenter')
		},
		className: "UserCenter"
	},
])

const routeName = ref("")

router.afterEach((to, from, next) => {
	routeName.value = to.name
})


const addAuthorizationBtn = () => {
	if (globalStore.siteSettings.authorizationArr && globalStore.siteSettings.authorizationArr.length > 0 && globalStore.siteSettings.authorizationArr[0] !== "") {
		headerItem.value.splice(3, 0, {
			type: 0,
			name: "授权展示",
			url: "/authorization",
			className: "Authorization"
		})
	}
}

bus.on('addAuthorizationBtn', addAuthorizationBtn);
onBeforeUnmount(() => {
	bus.off('addAuthorizationBtn', addAuthorizationBtn);
})

</script>
<style lang="scss" scoped>

@keyframes light {
	40% {
		left: -100px;
		top: 0;
	}

	60% {
		left: 120px;
		top: 100px;
	}

	80% {
		left: -100px;
		top: 0;
	}
}


.home-header-container {
	width: 1218px;
	display: flex;
	justify-content: space-between;
	transition: .1s;
	padding: 8px 0;

	//&.route-home {
	//	padding: 8px 0;
	//}

	.home-header-logo {
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: center;

		img {
			//height: 60px;
			width: 200px;
		}

		&:after {
			content: "";
			position: absolute;
			left: -665px;
			top: -460px;
			width: 300px;
			height: 15px;
			background-color: rgba(255, 255, 255, .5);
			transform: rotate(-45deg);
			animation: light 6s ease-in 0s infinite;
		}
	}

	.home-header-menu {
		border-bottom: none;

		li {
			font-size: 20px;
			color: #333;
			font-family: 'times new roman', times, serif;
			font-weight: bold;
			margin-left: 30px;

			a {
				transition: .2s;
				text-decoration: none;
				display: inline-block;


				&:hover, &.active {
					color: #eca222;
				}
			}

		}
	}
}

</style>